import ApiClient from './ApiClient';

// Motivos de pausa da conta: get() (todos, arquivados inclusos), create(),
// update(id, data). Sem delete — motivo se arquiva (active: false).
class PauseReasonsAPI extends ApiClient {
  constructor() {
    super('pause_reasons', { accountScoped: true });
  }
}

export default new PauseReasonsAPI();
